import { createApiClient } from '@oneblinktech-org/helios-base';

const apiUrl = process.env.REACT_APP_API_URL;
const { get, post } = createApiClient({ apiUrl });

export async function getProfile() {
    const token = localStorage.getItem('h-access_token')
    
    try {
        const result = await get('/users/profile', {
            "Authorization": `Bearer ` + token
        })
        return result
    } catch (e) {
        throw e
    }
}

export async function getOrgUsers() {
    const token = localStorage.getItem('h-access_token')

    try {
        const result = await get(`/settings/getUsersWithPortalAccess`, {
            "Authorization": `Bearer ` + token
        })
        return result
    } catch (e) {
        throw e
    }
}

export async function updateProfile(payload) {
    const token = localStorage.getItem('h-access_token')
    
    try {
        const result = await post('/users/profile', payload.form, {
            "Content-Type": 'multipart/form-data',
            "Authorization": `Bearer ` + token
        })
        return result
    } catch (e) {
        throw e
    }
}

export async function updateUserInOrg(payload) {
    const token = localStorage.getItem('h-access_token')
    try {
        const result = await post('/users/updateUserInOrg', payload, {
            "Authorization": `Bearer ` + token
        })
        return result
    } catch (e) {
        throw e
    }
}

export async function addUserInOrg(payload) {
    const token = localStorage.getItem('h-access_token')
    try {
        const result = await post('/users/addUserInOrg', payload, {
            "Authorization": `Bearer ` + token
        })
        return result
    } catch (e) {
        throw e
    }
}

export async function getGetUserTypes() {
    const token = localStorage.getItem('h-access_token')

    try {
        const result = await get('/userTypes', {
            "Authorization": `Bearer ` + token
        })
        return result
    } catch (e) {
        throw e
    }
}

export async function getGetUserRoles() {
    const token = localStorage.getItem('h-access_token')

    try {
        const result = await get('/userRoles', {
            "Authorization": `Bearer ` + token
        })
        return result
    } catch (e) {
        throw e
    }
}

export async function resetPassword(userId) {
    const token = localStorage.getItem('h-access_token')

    try {
        const result = await get('/users/reset_password/' + userId, {
            "Authorization": `Bearer ` + token
        })
        return result
    } catch (e) {
        throw e
    }
}
